/**
 * Race categories matching OMB 2024 Standards (SPD 15)
 * These align with federal data collection standards and California DOJ booking record categories
 */
export const RACES = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Hispanic or Latino',
  'Middle Eastern or North African',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Two or More Races'
];
